// extracted by mini-css-extract-plugin
module.exports = {"registerCards":"RegisterCards_registerCards__ecz2R","cardsContainer":"RegisterCards_cardsContainer__1lV3l","card":"RegisterCards_card__3Us8o"};